// export const SERVER_DOMAIN = 'localhost:3001';
// export const SERVER_URL = `http://${SERVER_DOMAIN}/api`;
// export const SERVER_TOKEN = 'USE_YOURS';
// export const FIREBASE_OPTIONS = {
//     apiKey:'ASK_ADMIN',
//     authDomain:'ASK_ADMIN',
//     projectId:'ASK_ADMIN',
//     storageBucket:'ASK_ADMIN',
//     messagingSenderId:'ASK_ADMIN',
//     appId:'ASK_ADMIN',
//     measurementId:'ASK_ADMIN',
// };
// export const SERVER_DOMAIN = 'taa.theappointmentapp.com';
export const SERVER_DOMAIN = 'taa.dukaani.in';
export const SERVER_URL = `https://${SERVER_DOMAIN}/api`;
export const SERVER_TOKEN = 'taa123';

// Firebase Web app config for project appointment-app-5b8a1
export const FIREBASE_OPTIONS = {
    apiKey: 'AIzaSyABHxyaYZTTQXrdteyweNo7xjXfXCSee78',
    authDomain: 'appointment-app-5b8a1.firebaseapp.com',
    projectId: 'appointment-app-5b8a1',
    storageBucket: 'appointment-app-5b8a1.firebasestorage.app',
    messagingSenderId: '72571116658',
    appId: '1:72571116658:web:0f0cc3ea38cbfdd3f476eb',
    measurementId: 'G-RLLD3FRMYJ',
};
// make secret.jsx file in the current directory and paste the above values and provide appropriate values
